import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4518a14f&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeHero: require('/app/channels2022/src/components/home-page/HomeHero.vue').default,HomeProducts: require('/app/channels2022/src/components/home-page/HomeProducts.vue').default,HomeBenefits: require('/app/channels2022/src/components/home-page/HomeBenefits.vue').default,SubscribeBanner2026: require('/app/channels2022/src/components/subscribe2026/SubscribeBanner2026.vue').default,HomeExplore: require('/app/channels2022/src/components/home-page/HomeExplore.vue').default,HomeLicensing: require('/app/channels2022/src/components/home-page/HomeLicensing.vue').default,HomeTestimonials: require('/app/channels2022/src/components/home-page/HomeTestimonials.vue').default,HomePartners: require('/app/channels2022/src/components/home-page/HomePartners.vue').default,HomeFaqs: require('/app/channels2022/src/components/home-page/HomeFaqs.vue').default})
